import { render, staticRenderFns } from "./business-type.vue?vue&type=template&id=00a86948&"
import script from "./business-type.vue?vue&type=script&lang=js&"
export * from "./business-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports